import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderInterface } from 'src/interfaces/orderData.interface';
import { SharedService } from 'src/providers/http/shared.service';
import { SnackbarService } from 'src/providers/http/snack-bar.service';
import { TradingdeskService } from 'src/providers/http/tradingdesk.service';

interface stat {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-stocks-buysell-model',
  templateUrl: './stocks-buysell-model.component.html',
  styleUrls: ['./stocks-buysell-model.component.scss']
})
export class StocksBuysellModelComponent implements OnInit {
  stats: stat[] = [
    { value: 'Single-Leg', viewValue: 'Singleleg' },
    { value: 'Two-Leg', viewValue: 'Twoleg' },
  ];
  activateSell: boolean = false;
  selectedStatus: any = 'Single-Leg';
  Status: string;
  checked: boolean;
  buyorderForm: any;
  balance: any;
  showlowBalance: boolean;
  userId: any;
  copytraderId: string = null;
  toggleValue: boolean;
  bucketOrder: number = 1;
  loader: boolean;
  disableLimitOrder: boolean;
  showBreakoutStrategy: boolean;
  doubleLegged: any;
  bal: number = 0;
  exchange: any;
  price: any;
  enteredAmount: any;
  onlyToread: boolean;
  onlyTowrite: boolean;
  showOptionLeg: boolean = true;
  value: any;
  constructor(
    public dialogRef: MatDialogRef<StocksBuysellModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _shared: SharedService,
    private _form: FormBuilder,
    private _tradingdesk: TradingdeskService,
    private _snackbar: SnackbarService,
  ) { }

  ngOnInit(): void {
    this._shared.tradingdesk$.subscribe((data) => {
      if (JSON.stringify(data) == '{}') {
        this.loader = true;
      } else {
        this.data = data;
        this.loader = false;
        if (data.direction == 'sell') {
          this.toggleValue = true;
          this.activateSell = true;
        } else if (data.direction == 'buy') {
          this.toggleValue = false;
          this.activateSell = false;
        }
        this._shared.getExchanges().subscribe({
          next: (res: any) => {
            let data = res.data.brokerOrExchangesList.filter(
              (broker: any) => broker.brokerOrExchangeName == this.data.broker
            );
            if (data[0].brokerOrExchangeSupportTypes == 'stocks') {
              this.showBreakoutStrategy = true;
              this.disableLimitOrder = true;
            }
          },
          error: (err: any) => {
            this._snackbar.error('Something caused error, retry');
          },
        });

        this.buyorderForm = this._form.group({
          amount: [this.data.price, [Validators.required]],
          number_of_coins: [1, [Validators.required]],
          market: ['M', [Validators.required]],
        });
      }

      this._shared.balanceOb$.subscribe((bal) => {
        this.balance = bal;
        // this.checkForLowBal();
      });

      setTimeout(() => {
        this.hideOptionLeg();
      }, 100);

    });
    this.stocksMargin();
    this.value = this.buyorderForm.value.market
  }

  hideOptionLeg() {
    if (this.data.broker === 'iifl' || this.data.broker === 'zerodha') {
      if (this.data.instrument == 'FUT') {
        this.showOptionLeg = false;
      } else if (this.data.exchange) {
        this.showOptionLeg = false;
      }
    }
  }

  // Handle toggle change
  onToggleChange() {
    console.log('Toggle changed. Current state:', this.activateSell);
    // Add any additional logic here if needed
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  toggleChanged(event: any) {
    this.checked = event.checked;
  }

  toggleChanges(event: any) {
    this.checked = event.checked;
  }

  trimSymboltillCPType(symbol: string, cpType: string) {
    const index = symbol.indexOf(cpType);
    if (index === -1) {
      return symbol;
    }
    return symbol.substring(0, index + 2);
  }


  placeTrade(direction:string) {
    if (this.checked) {
      this.bucketOrder = this.bucketOrder;
    } else {
      this.bucketOrder = 1;
    }
    // if (this.showBreakoutStrategy) {  //------> working on this order placing logic with eq and d
    //   if (this.data.instrument == 'D' && this.doubleLegged) {
    //   } else if (this.data.instrument == 'D' && !this.doubleLegged) {
    //     this.data.symbol = this.trimSymboltillCPType(
    //       this.data.symbol,
    //       this.data.symbol.split(' ')[4]
    //     );
    //   }
    // }
    if (this.data.broker == 'iifl') {

      if (this.data.instrument == 'C') {
        this.exchange = this.data.exchange;
        if (this.buyorderForm.value.market == 'M') {
          this.onlyToread = true;
          this.onlyTowrite = false;
          this.price = 0;
        } else {
          this.price = this.enteredAmount;
        }
      } else if (this.data.instrument == 'D') {
        const symbol = this.data.symbol;

        // Extract exchange (CE or PE)
        const exchangeMatch = symbol.match(/\b(CE|PE)\b/);
        this.exchange = exchangeMatch ? exchangeMatch[0] : "";

        if (this.exchange == 'FUT') {
          if (this.buyorderForm.value.market == 'M') {
            this.onlyToread = true;
            this.onlyTowrite = false;
            this.price = 0;
          } else {
            this.price = this.enteredAmount;
          }
        } else {
          const priceMatch = symbol.match(/(\d+\.\d+)$/);
          this.price = priceMatch ? parseFloat(priceMatch[0]) : 0;
        }
        // Extract price (last numeric value)

      }

    } else if (this.data.broker == 'zerodha') {
      if (this.data.instrument == 'EQ') {
        this.exchange = this.data.exchange;
        if (this.buyorderForm.value.market == 'M') {
          this.onlyToread = true;
          this.onlyTowrite = false;
          this.price = 0;
        } else {
          this.price = this.enteredAmount;
        }

      } else if (this.data.instrument == 'FUT') {
        this.exchange = this.data.exchange;
        if (this.buyorderForm.value.market == 'M') {
          this.onlyToread = true;
          this.onlyTowrite = false;
          this.price = 0;
        } else {
          this.price = this.enteredAmount;
        }
      } else if (this.data.instrument == 'D') {
        this.exchange = this.data.exchange;
        if (this.buyorderForm.value.market == 'M') {
          this.onlyToread = true;
          this.onlyTowrite = false;
          this.price = 0;
        } else {
          this.price = this.enteredAmount;
        }

      } else if (this.data.instrument == 'CE' || 'PE') {
        const symbol = this.data.symbol;
        this.exchange = this.data.exchange;
        this.price = this.data.price;
        // Extract exchange (CE or PE)
        // const exchangeMatch = symbol.match(/\b(CE|PE)\b/);
        // this.exchange = exchangeMatch ? exchangeMatch[0] : "";

        // Extract price (last numeric value)
        // const priceMatch = symbol.match(/(\d+\.\d+)$/);
        // this.price = priceMatch ? parseFloat(priceMatch[0]) : 0;
      }
    } else if (this.data.broker == 'ib') {
      this.exchange = this.data.exchange;
      if (this.buyorderForm.value.market == 'M') {
        this.onlyToread = true;
        this.onlyTowrite = false;
        this.price = null;
      } else {
        this.price = this.enteredAmount;
      }
    }



    const placeOrderData: OrderInterface = {
      userId: this.data.userId,
      data: {
        uniqueId: this.data.uniqueId,
        broker: this.data.broker,
        symbol: this.data.symbol,
        orderType: this.buyorderForm.value.market,
        price: this.price,
        quantity: this.buyorderForm.value.number_of_coins.toString(),
        direction: direction,
        exchange: this.exchange || null,
        instrument: this.data.instrument || null,
        expiryDate: this.data.expiryDate || null,
        strike: this.data.strike || null,
        right: this.data.right || null,
        uoid: null,
        userId: this.data.userId,
        masterOrderId: null,
        copyTradeId: this.data.copyTradeId,
        copyCatId: null,
        tradeType: this.data.tradeType,
        bucketOrder: this.bucketOrder,
      },
    };
    // console.log(placeOrderData, 'placeOrderData==========')
    this._tradingdesk.placeOrder(placeOrderData).subscribe({
      next: (res: any) => {
        this._snackbar.success(res.data.message);
        this.dialogRef.close(true);
      },
      error: (err: any) => {
        this._snackbar.error(err.error.data.message);
        this.dialogRef.close(false);
      },
    });
  }



  stocksMargin() {
    console.log(this.data.uniqueId, 'this.data.uniqueId')
    if (this.data.broker == 'iifl') {
      this._tradingdesk.getIIFLMargin(this.data.uniqueId).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.bal = res.data.balance;
          }
        },
        error: (err: any) => {
          this.bal = null;
          this._snackbar.error(err.error.data.message)
        }
      })
    } else if (this.data.broker == 'zerodha') {
      this._tradingdesk.getZERODHAMargin(this.data.uniqueId).subscribe({
        next: (res: any) => {
          if (res.status == 'success') {
            this.bal = res.data.balance;
          }
        },
        error: (err: any) => {
          this.bal = null;
          this._snackbar.error(err.error.data.message)
        }
      })
    } else if (this.data.broker == 'ib') {
      this._tradingdesk.getIBMargin(this.data.uniqueId).subscribe({
        next: (res: any) => {
          const inrBalance = res.balance.find((item: any) => item.includes("INR"));
          this.bal = inrBalance ? parseFloat(inrBalance.split(" ")[0]) : null;
          // if (res.status == 'success') {
          //   this.bal = res.data.balance;
          // }
        },
        error: (err: any) => {
          this.bal = null;
          this._snackbar.error(err.error.data.message)
        }
      })
    }




    // if (brokerName == 'iifl') {
    //   this._tradingdesk.getIIFLMargin('2051710307703061').subscribe({
    //     next: (res: any) => {
    //       if (res.status == 'success') {
    //         this.bal = res.data.balance;
    //       }
    //     },
    //     error: (err: any) => {
    //       this.bal = null;
    //       this._snackbar.error(err.error.data.message)
    //     }
    //   })
    // }
    // else if (brokerName == 'zerodha') {
    //   this._tradingdesk.getZERODHAMargin(uniqueId).subscribe({
    //     next: (res: any) => {
    //       if (res.status == 'success') {
    //         this.bal = res.data.balance;
    //       }
    //     },
    //     error: (err: any) => {
    //       this.bal = null;
    //       this._snackbar.error(err.error.data.message)
    //     }
    //   })
    // }

  }
  // this.holdings = this.holdings.filter(
  //   (holding) =>
  //     !this.positions.some(
  //       (position) =>
  //         holding.Symbol === position.ScripName &&
  //         holding.Quantity === position.NetQty
  //     )
  // );

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && charCode != 46 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  quantityChange(event: any) {
    let qtyChange = event.target.value;
    let price = this.data.price || 1; 
    this.buyorderForm.get('amount').setValue(qtyChange * price);
  }

  amountChange(event: any) {
    this.enteredAmount = event.target.value;
    let amountChange = event.target.value;
    let price = this.data.price ;
    // this.buyorderForm.get('number_of_coins').setValue(amountChange / price);
  }


  bucketChange(event: any) {
    let bktChange = event.target.value;
    if (bktChange == 0) {
      this.bucketOrder = 1;
    } else {
      this.bucketOrder = bktChange;
    }
  }
}

